import moment from 'moment'
import React from 'react'
class CommonFooter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  navigation = val => {
    if (val === 'linkedin') {
      window.open('https://www.linkedin.com/company/universal-health-fellowship/')
    }
    if (val === 'facebook') {
      window.open('https://www.facebook.com/universalhealthshare/')
    }
    if (val === 'instagram') {
      window.open('https://www.instagram.com/universalhealthfellowship/')
    }
  }

  render() {
    return (
      <div style={{ backgroundColor: '#E4EFFC', bottom: 0, left: 0, right: 0, position: 'static' }}>
        <div style={{ padding: '15px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div>
            <p className="fontStyles footerIcons" style={{ fontSize: '11px', color: '#333333' }}>
              Copyright © {moment().format("YYYY")} Universal Health Fellowship. All rights reserved. | Powered by CarynHealth <br />
              Version 5.0.0
            </p>
          </div>
          <div className="fontStyles footerIcons">
            <SocialIcon icon={'LinkedIn icon.svg'} onClick={() => this.navigation('linkedin')} />
            <SocialIcon icon={'Facebook icon.svg'} onClick={() => this.navigation('facebook')} />
            <SocialIcon icon={'Instagram icon.svg'} onClick={() => this.navigation('instagram')} />
          </div>
        </div>
      </div>
    )
  }
}
export default CommonFooter

const SocialIcon = ({ icon, onClick }) => {
  return <img width={35} src={require(`../Images/NewIcons/${icon}`)} style={{ marginRight: 10, cursor: 'pointer',position: 'unset' }} onClick={onClick} />
}
